import { render, staticRenderFns } from "./NotificationList.vue?vue&type=template&id=2013d04b&scoped=true&"
import script from "./NotificationList.vue?vue&type=script&lang=js&"
export * from "./NotificationList.vue?vue&type=script&lang=js&"
import style0 from "./NotificationList.vue?vue&type=style&index=0&id=2013d04b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2013d04b",
  null
  
)

export default component.exports